@if (!homepage) {
  <div class="option" tabindex="0" (click)="showRegisterUpgradeProduct()">
    <img [src]="'./assets/images/s16-box.png'" style="max-width: 80px" />
    <span class="brandfont-bold plan-title m-b-10">{{ isUpgrade ? "Studio One Pro Upgrade" : "Studio One Pro" }}</span>
    @if (isUpgrade) {
      <span class="t-14">{{ "newdash.studio_one_pro_seven_perpetual_upgrade" | translate }}</span>
    }
    @if (!isUpgrade) {
      <span class="t-14">{{ "newdash.studio_one_pro_seven_perpetual" | translate }}</span>
    }
    @if (discountedMinimumProductPrice) {
      <span class="brandfont-bold" [ngStyle]="{ 'text-decoration': 'line-through' }">{{ minimumProductPrice | currency: displayCurrency.toUpperCase() }}</span>
      <span class="brandfont-bold c-link-blue">{{ discountedMinimumProductPrice | currency: displayCurrency.toUpperCase() }}</span>
    }
    @if (!discountedMinimumProductPrice) {
      @if (minimumProductPrice) {
        <span class="t-14 bold d-block m-t-10">{{ minimumProductPrice | currency: displayCurrency.toUpperCase() }}</span>
      }
    }
    <span class="brand-btn-reverse d-block m-t-10" data-cy="register-key-button">{{ "product_detail.buy_now" | translate }}</span>
  </div>
}

@if (homepage) {
  <div class="align-items-center m-b-50 offer-container">
    <img
      [src]="env.features.studio_one_seven ? './assets/images/studio-one-7-box-screen.png' : './assets/images/s1-demo.png'"
      class="m-r-20 offer-image"
      style="max-width: 300px; display: inline-block"
      width="100%"
    />
    <div class="offer-text">
      <h5 class="brandfont-bold">{{ title | translate }}</h5>
      @if (appliedActiveOffer) {
        <span class="brandfont-black c-link-blue d-block">{{ appliedActiveOffer.display_message }}</span>
      }
      <span>
        {{ isUpgrade ? "Upgrade to" : "Purchase" }} a Studio One Pro 7 perpetual license and get all the latest features, including AI-powered stem separation, integrated Dolby Atmos mixing and
        rendering, Splice Search with Sound and 2,500+ bundled Splice samples, plus unlimited tracks, FX channels, buses, 8 virtual instruments, and dozens of native effects plug-ins.
      </span>
      <br />
      <br />
      @if (activeCurrency) {
        <button class="btn btn-primary" (click)="showRegisterUpgradeProduct()">
          @if (discountedMinimumProductPrice) {
            {{ (isUpgrading ? "product_detail.upgrade.upgrade" : "product_detail.buy_now") | translate }}
            <span class="brandfont-bold" [ngStyle]="{ 'text-decoration': 'line-through' }">
              {{ minimumProductPrice | currency: displayCurrency.toUpperCase() }}
            </span>
            <span class="brandfont-black">&nbsp;&nbsp;{{ discountedMinimumProductPrice | currency: displayCurrency.toUpperCase() }}</span>
          }
          @if (!discountedMinimumProductPrice) {
            @if (minimumProductPrice) {
              <span class="t-14 bold d-block">
                {{ (isUpgrading ? "product_detail.upgrade.upgrade" : "product_detail.buy_now") | translate }} {{ minimumProductPrice | currency: displayCurrency.toUpperCase() }}
              </span>
            }
          }
        </button>
      }
    </div>
  </div>
}
